import Vue from "vue";
import {
    store
} from "./Store"
import Router from "vue-router";
const FrontPage = () => import("./pages/frontpage.vue");
const Navbar = () => import("./layout/Nav.vue");
const Common = () => import('./pages/common.vue');
const Reports = () => import('./pages/reports.vue');
const PaginatedReports = () => import('./pages/paginatedreports.vue');
const Sidebar = () => import('./pages/sidebar.vue');
const BulkUpload = () => import('./pages/bulkupload.vue');
const meta  = require('./meta.json')
Vue.use(Router);
const w = Vue.prototype;

const routes = [{
    path: "/",
    name: "frontpage",
    components: {
        default: FrontPage,
        header: Navbar
    },
    meta: {
        page: 1
    },
    props: {
        header: {
            colorOnScroll: 675
        }
    }
},
{
    path: "/commitment",
    name: "commitment",
    components: {
        default: Common,
        menu: Sidebar,
        header: Navbar
    },
    meta: {
        page: 2,
        module: 'Commitment',
        subModule: '',
        gqlmap: 'commitment',
        requireAuth: true
    },
    props: {
        header: {
            colorOnScroll: 675
        }
    }
},
{
    path: "/entitydb/cd",
    name: "EntityDB",
    components: {
        default: Common,
        menu: Sidebar,
        header: Navbar
    },
    meta: {
        page: 2,
        module: 'EntityDB',
        subModule: 'Company Details',
        gqlmap: 'entitydbCd',
        requireAuth: true
    },
    props: {
        header: {
            colorOnScroll: 675
        }
    }
},
{
    path: "/entitydb/rt",
    name: "EntityDB",
    components: {
        default: Common,
        menu: Sidebar,
        header: Navbar
    },
    meta: {
        page: 2,
        module: 'EntityDB',
        subModule: 'Regulatory Tax',
        gqlmap: 'entitydbRt',
        requireAuth: true
    },
    props: {
        header: {
            colorOnScroll: 675
        }
    }
},
{
    path: "/entitydb/la",
    name: "EntityDB",
    components: {
        default: Common,
        menu: Sidebar,
        header: Navbar
    },
    meta: {
        page: 2,
        module: 'EntityDB',
        subModule: 'LPA Amendments',
        gqlmap: 'entitydbLa',
        requireAuth: true
    },
    props: {
        header: {
            colorOnScroll: 675
        }
    }
},
{
    path: "/entitydb",
    name: "EntityDB",
    components: {
        default: Common,
        menu: Sidebar,
        header: Navbar
    },
    meta: {
        page: 2,
        module: 'EntityDB',
        subModule: '',
        gqlmap: 'entitydb',
        requireAuth: true
    },
    props: {
        header: {
            colorOnScroll: 675
        }
    }
},
{
    path: "/odd",
    name: "odd",
    components: {
        default: Common,
        menu: Sidebar,
        header: Navbar
    },
    meta: {
        page: 2,
        module: 'ODD',
        subModule: ' ',
        gqlmap: 'odd',
        requireAuth: true
    },
    props: {
        header: {
            colorOnScroll: 675
        }
    }
},
{
    path: "/GPMaster",
    name: "GPMaster",
    components: {
        default: Common,
        menu: Sidebar,
        header: Navbar
    },
    meta: {
        page: 2,
        module: 'GP Master',
        subModule: '',
        gqlmap: 'excavation',
        requireAuth: true
    },
    props: {
        header: {
            colorOnScroll: 675
        }
    }
},
{
    path: "/Fund",
    name: "Fund",
    components: {
        default: Common,
        menu: Sidebar,
        header: Navbar
    },
    meta: {
        page: 2,
        module: 'Funds',
        subModule: '',
        gqlmap: 'excavation',
        requireAuth: true
    },
    props: {
        header: {
            colorOnScroll: 675
        }
    }
},
{
    path: "/Direct",
    name: "Direct",
    components: {
        default: Common,
        menu: Sidebar,
        header: Navbar
    },
    meta: {
        page: 2,
        module: 'Direct',
        subModule: '',
        gqlmap: 'excavation',
        requireAuth: true
    },
    props: {
        header: {
            colorOnScroll: 675
        }
    }
},
{
    path: "/excavation",
    name: "excavation",
    components: {
        default: Common,
        menu: Sidebar,
        header: Navbar
    },
    meta: {
        page: 2,
        module: 'Excavation',
        subModule: ' ',
        gqlmap: 'excavation',
        requireAuth: true
    },
    props: {
        header: {
            colorOnScroll: 675
        }
    }
},
{
    path: "/Asset",
    name: "Asset",
    components: {
        default: Common,
        menu: Sidebar,
        header: Navbar
    },
    meta: {
        page: 2,
        module: 'Assets',
        subModule: '',
        gqlmap: 'excavation',
        requireAuth: true
    },
    props: {
        header: {
            colorOnScroll: 675
        }
    }
},
{
    path: "/LEFund",
    name: "Legal Entity Funds",
    components: {
        default: Common,
        menu: Sidebar,
        header: Navbar
    },
    meta: {
        page: 2,
        module: 'Legal Entity Funds',
        subModule: '',
        gqlmap: 'excavation',
        requireAuth: true
    },
    props: {
        header: {
            colorOnScroll: 675
        }
    }
},
{
    path: "/FundAsset",
    name: "FundAsset",
    components: {
        default: Common,
        menu: Sidebar,
        header: Navbar
    },
    meta: {
        page: 2,
        module: 'Fund Assets',
        subModule: '',
        gqlmap: 'excavation',
        requireAuth: true
    },
    props: {
        header: {
            colorOnScroll: 675
        }
    }
},
{
    path: "/paginated",
    name: "Paginated Reports",
    components: {
        default: PaginatedReports,
        menu: Sidebar,
        header: Navbar
    },
    meta: {
        page: 2,
        report: 'test',
        module: 'Fund Assets Cash',
        subModule: '',
        gqlmap: 'excavation',
        requireAuth: true
    },
    props: {
        header: {
            colorOnScroll: 675
        }
    }
},
{
    path: "/reports/:id",
    name: "Reports",
    components: {
        default: Reports,
        menu: Sidebar,
        header: Navbar
    },
    meta: {
        page: 2,
        report: 'test',
        module: 'Fund Assets Cash',
        subModule: '',
        gqlmap: 'excavation',
        requireAuth: true
    },
    props: {
        header: {
            colorOnScroll: 675
        }
    }
},
{
    path: "/CashManagement/bulkupload",
    name: "BulkUpload",
    components: {
        default: BulkUpload,
        menu: Sidebar,
        header: Navbar
    },
    meta: {
        page: 2,
        report: 'test',
        module: 'Fund Assets Cash',
        subModule: '',
        gqlmap: 'excavation',
        requireAuth: true
    },
    props: {
        header: {
            colorOnScroll: 675
        }
    }
}
]
const cash  = {
    path: "/CashManagement/ivoryIv",
    name: "CashManagement",
    components: {
        default: Common,
        menu: Sidebar,
        header: Navbar
    },
    meta: {
        page: 2,
        module: 'Cash Management',
        subModule: 'Ivory IV',
        gqlmap: 'ivoryIv',
        subgql: 'ivoryIv',
        fund: 'FundVI',
        fundid: 'Asia Alternatives Ivory Partners IV, L.P.',
        requireAuth: true
    },
    props: {
        header: {
            colorOnScroll: 675
        }
    }
}
routes.push(cash);
meta.forEach( x => {
let template = JSON.parse(JSON.stringify(cash))
let map = x.module.replace(/ /g, '_').replace(/\(/g,'').replace(/\)/g,'')
template.components = cash.components;
template.name = "CashManagement" + "_" + map
template.path = "/CashManagement/" + map
template.meta.TrancheII = x.TrancheII || false;
template.meta.mma = x.MMA || false;
template.meta.fundid = x.name
template.meta.fund = x.fund || cash.fund
template.meta.subModule = x.subModule || x.module
template.meta.subgql = 'Ivory IV'
routes.push(template);
})
const router = new Router({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    store.commit('change', {
        target: false
    });
    if (to.meta && to.meta.module) {
        store.commit('change', {
            module: to.meta.module
        });
    }
    if (to.meta && to.meta.subModule) {
        store.commit('change', {
            subModule: to.meta.subModule
        });
    }
    if (to.meta && to.meta.gqlmap) {
        store.commit('change', {
            gqlmap: to.meta.gqlmap
        });
        if ( to.meta.subgql ) {
        store.commit('change', {
            subql: to.meta.subgql
        });
        }
        if ( to.meta.fund ) {
        store.commit('change', {
            fund: to.meta.fund
        });
        }
        if ( to.meta.fundid ) {
        store.commit('change', {
            fundid: to.meta.fundid
        });
        }
        if ( to.meta.TrancheII ) {
        store.commit('change', {
            TrancheII: to.meta.TrancheII
        });
        } else {
        store.commit('change', {
            TrancheII: null
        });
        }
        if ( to.meta.mma ) {
        store.commit('change', {
            mma: to.meta.mma
        });
        } else {
        store.commit('change', {
            mma: null
        });
        }
    } else {
        store.commit('change', {
            gqlmap: null
        });
    }
    if (to.matched.some(record => record.meta.requireAuth)) {
        store.commit('change', {
            slideWrapper: 'hidden'
        });
        if (!store.getters.get('user')) {
            store.commit('change', {
                target: to.name
            });
            var init = JSON.parse(store.getters.get('init'))
            init.target = to.name
            store.commit('change', {
                init: JSON.stringify(init)
            });
            w.$adal.login()
            let user = w.$adal.user
            if (user === 'xyz') {
                store.commit('change', {
                    user: {
                        username: user.userName
                    }
                })
                next()
            } else {
                next({
                    path: '/'
                });
            }
        } else {
            next()
        }
    } else {
        next()
    }
})
export default router
